export default "__VITE_ASSET__8ee6e65b__"